import React, { useState, useCallback } from 'react';
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { CreateTable } from "./Tables";
import { Button, SearchBar } from "../../../common/APICommon";
import { ViewEmployeeModal as ViewEmployee } from "../../Personnel/ViewEmployee";

// V2 Imports
import { useFilterManager } from '../../../v2/hooks/useFilterManager';
import { useEmployees } from '../../../v2/hooks/useEmployees';
import { DynamicFilterBar } from '../../../v2/components/filters/DynamicFilterBar';
import { fetchFullEmployeeDetails } from '../../Personnel/EmployeesListFld/EmployeesListApi';
import { LoadingSpinner } from '../../../common/Loading';
import { FEATURES } from '../../../config/features';

export const EmployeeTabs = ({ user, userAccessData, employeePhoto, setEmployeePhoto }) => {
  // 1. Manage Dynamic Filters
  const {
    activeFilterState,
    onFilterChange,
    apiFilterPayload,
    applyFilters,
    resetFilters,
    loadingEnums
  } = useFilterManager(['CLIENT', 'DEPARTMENT', 'POSITION', 'VESSEL', 'EMPLOYEE_TYPE']);

  // 2. Manage Employee Data & Search
  const {
    employees,
    loading: loadingData,
    handleSearch,
    refresh
  } = useEmployees(apiFilterPayload, loadingEnums);

  // 3. Local UI States for this feature
  const [currentPage, setCurrentPage] = useState(1);
  const [showViewEmployee, setShowViewEmployee] = useState(false);
  const [viewedData, setViewedData] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);

  const header = ["ID", "Full Name", "Department", "Position", ""];
  const accessor = ["employeeId", "fullName", "employeeInformation.departmentDescription", "employeeInformation.positionDescription", "manage"];

  // Handlers
  const addHandleClick = () => { window.location.pathname = "/addEmployee"; };

  const viewEmployeeHandleClick = useCallback(async (data) => {
    setLoadingModal(true);
    try {
      const fullEmployeeData = await fetchFullEmployeeDetails(data.id);
      setViewedData(fullEmployeeData);
      setShowViewEmployee(true);
    } finally {
      setLoadingModal(false);
    }
  }, []);

  return (
    <div>
      {/* Dynamic Filter Section */}
      <div className="py-0 px-3">
        <div className="bg-white rounded-lg border border-gray-200 mt-2 p-4" style={{ border: "1px solid #d7d7d7" }}>
          <span className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-4 block">Filter Personnel</span>
          <DynamicFilterBar
            requestedFilters={FEATURES.EMPLOYEE_FILTERS}
            activeFilterState={activeFilterState}
            onFilterChange={onFilterChange}
            onApply={applyFilters}
            onClear={resetFilters}
          />
        </div>
      </div>

      {/* Table Top Controls */}
      <div className="top-table row">
        <div className="left w-1/2">
          <SearchBar handleFilter={(val) => handleSearch(val)} />
        </div>
        <div className="right row w-1/2">
          <Button
            icon={<PeopleAltIcon fontSize="small" />}
            name={"ADD EMPLOYEE"}
            className="bg-customGreen hover:bg-customGreen text-white"
            onClick={addHandleClick}
          />
        </div>
      </div>

      {/* Employee Table */}
      <div id="container1" className="InfoList container">
        <CreateTable
          dataList={employees}
          dataHeader={header}
          dataAccessor={accessor}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          editHandleClick={viewEmployeeHandleClick}
        />
      </div>

      {/* Localized Modal */}
      {showViewEmployee && (
        <ViewEmployee
          user={user}
          isOpen={showViewEmployee}
          onClose={() => setShowViewEmployee(false)}
          viewedData={viewedData}
          setViewedData={setViewedData}
          fetchData={refresh}
          employeePhoto={employeePhoto}
          setEmployeePhoto={setEmployeePhoto}
        />
      )}

      <LoadingSpinner loading={loadingData || loadingEnums || loadingModal} />
    </div>
  );
};